import { createFeatureSelector } from '@ngrx/store';
import { BOOKING_SEARCH_STORE_NAME, BookingSearchState } from './booking-search.state';

/** Select BookingSearch State */
export const selectBookingSearchState = createFeatureSelector<BookingSearchState>(BOOKING_SEARCH_STORE_NAME);
